import Up from "components/icons/up"
import Down from "components/icons/down"

export default function ShortNavigator({ currentIndex, total, scrollToPrev, scrollToNext }) {
  return (
    <div className="fixed top-1/2 right-2 transform -translate-y-1/2 z-20 flex flex-col gap-4 text-white/70">
      <button
        onClick={scrollToPrev}
        disabled={currentIndex === 0}
        className={`hover:text-white transition ${currentIndex === 0 ? "opacity-30 cursor-not-allowed" : ""}`}
      >
        <Up status={currentIndex === 0} />
      </button>

      <button
        onClick={scrollToNext}
        disabled={currentIndex >= total - 1}
        className={`hover:text-white transition ${currentIndex >= total - 1 ? "opacity-30 cursor-not-allowed" : ""}`}
      >
        <Down status={currentIndex >= total - 1} />
      </button>
    </div>
  )
}
